/**
 * Fill Notification Component — visual-only.
 *
 * Sound is handled imperatively by useOrderManagement.handleFill().
 */

import React from 'react';
import type { FillNotification } from '../types';

interface FillNotificationProps {
  fill: FillNotification;
}

const FillNotificationComponent: React.FC<FillNotificationProps> = ({ fill }) => {
  return (
    <div className="fill-notification">
      <div className="fill-notification-content">
        <strong>Order Filled</strong>
        <div>
          {fill.action.toUpperCase()} {fill.quantity} {fill.side.toUpperCase()} @{' '}
          {fill.price.toFixed(4)}
        </div>
        <div className="fill-ticker">{fill.ticker}</div>
      </div>
    </div>
  );
};

export default FillNotificationComponent;
